module.exports = __webpack_public_path__ + "static/media/25487228_1703513013057216_7386517107176716469_o.246408fe.jpg";